import { createFileRoute } from '@tanstack/react-router';

import { ArticleSearchClaimable } from '@/module/Author/Article/ArticleSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/article/_article/search-claimable')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ArticleSearchClaimable />;
}
